export default function Error500() {
  return (
    <div className="misc-wrapper">
      <h2 className="mb-2 mx-2">Mất kết nối tới server... 🔌</h2>
      <h5 className="mb-6 mx-sm-2 text-center">Thử tải lại trang hoặc vui lòng quay lại sau!</h5>
      <div className="d-flex justify-content-center mt-9">
        <img src="/assets/img/illustrations/misc-under-maintenance-object.png" alt="misc-under-maintenance" className="img-fluid misc-object d-none d-lg-inline-block" width="170" />
        <img src="/assets/img/illustrations/misc-bg-light.png" alt="misc-under-maintenance" className="misc-bg d-none d-lg-inline-block" />
        <div className="d-flex flex-column align-items-center z-3">
          {/*<img src="/assets/img/maintenance.png" alt="misc-under-maintenance" className="img-fluid z-1" width="290" />*/}
          <a href="/" className="btn btn-primary waves-effect waves-light" >
            Tải lại trang
          </a>

        </div>
      </div>
    </div>
  );
}
